import { render, staticRenderFns } from "./EmpresaEstado.vue?vue&type=template&id=c64d18fc"
import script from "./EmpresaEstado.vue?vue&type=script&lang=js"
export * from "./EmpresaEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports